// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --awl-primary: #01978d; 
  --text-dark: #1f2937;
  --text-light: #6b7280;
  --bg-main: #f3f4f6; 
  --bg-card: #ffffff;
  --border-color: #e5e7eb;
  --danger-color: #ef4444;
}

.menu-page {
  background-color: var(--bg-main);
  padding: 1.5rem;
  padding-bottom: 10.5rem; 
}

.page-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-dark);
  text-align: center;
  margin-bottom: 1.5rem;
}

.menu-card {
  padding: 0.5rem; 
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--border-color);
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.menu-item:last-child {
  border-bottom: none;
}

.menu-item:hover {
  background-color: #f9fafb;
}

.menu-icon {
  font-size: 1.25rem;
  margin-right: 1rem;
  color: var(--text-light);
}

.menu-label {
  flex-grow: 1;
  font-weight: 600;
  color: var(--text-dark);
}

.menu-chevron {
  font-size: 1.25rem;
  font-weight: 300;
  color: var(--text-light);
}

.logout-section {
  margin-top: 1.5rem;
}

.logout-btn {
  width: 100%;
  background-color: #fee2e2;
  color: var(--danger-color);
  padding: 0.9rem 1rem;
  border-radius: 0.75rem;
  font-weight: 700;
  font-size: 1rem;
  border: 1px solid #fecaca;
  cursor: pointer;
  transition: all 0.2s ease;
}

.logout-btn:hover {
  background-color: var(--danger-color);
  color: white;
  border-color: var(--danger-color);
}`, "",{"version":3,"sources":["webpack://./src/Menu.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,4CAA4C;EAC5C,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,0BAA0B;EAC1B,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,iCAAiC;AACnC","sourcesContent":[":root {\n  --awl-primary: #01978d; \n  --text-dark: #1f2937;\n  --text-light: #6b7280;\n  --bg-main: #f3f4f6; \n  --bg-card: #ffffff;\n  --border-color: #e5e7eb;\n  --danger-color: #ef4444;\n}\n\n.menu-page {\n  background-color: var(--bg-main);\n  padding: 1.5rem;\n  padding-bottom: 10.5rem; \n}\n\n.page-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--text-dark);\n  text-align: center;\n  margin-bottom: 1.5rem;\n}\n\n.menu-card {\n  padding: 0.5rem; \n}\n\n.menu-item {\n  display: flex;\n  align-items: center;\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid var(--border-color);\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.menu-item:last-child {\n  border-bottom: none;\n}\n\n.menu-item:hover {\n  background-color: #f9fafb;\n}\n\n.menu-icon {\n  font-size: 1.25rem;\n  margin-right: 1rem;\n  color: var(--text-light);\n}\n\n.menu-label {\n  flex-grow: 1;\n  font-weight: 600;\n  color: var(--text-dark);\n}\n\n.menu-chevron {\n  font-size: 1.25rem;\n  font-weight: 300;\n  color: var(--text-light);\n}\n\n.logout-section {\n  margin-top: 1.5rem;\n}\n\n.logout-btn {\n  width: 100%;\n  background-color: #fee2e2;\n  color: var(--danger-color);\n  padding: 0.9rem 1rem;\n  border-radius: 0.75rem;\n  font-weight: 700;\n  font-size: 1rem;\n  border: 1px solid #fecaca;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.logout-btn:hover {\n  background-color: var(--danger-color);\n  color: white;\n  border-color: var(--danger-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
